import type { Role } from "@/types";

export interface NavItem {
  key: string;
  label: string;
  icon: string;
  path: string;
  phase?: number;
}

export const ADMIN_NAV: NavItem[] = [
  { key: "dashboard", label: "Panel Ejecutivo", icon: "ri-dashboard-3-line", path: "/admin" },
  { key: "catalogo", label: "Catálogo Amway", icon: "ri-store-2-line", path: "/admin/catalogo" },
  { key: "inventario", label: "Inventario Consolidado", icon: "ri-archive-2-line", path: "/admin/inventario" },
  { key: "ventas", label: "Ventas & CRM", icon: "ri-shopping-bag-3-line", path: "/admin/ventas" },
  { key: "consignaciones", label: "Consignación & Asesores", icon: "ri-hand-heart-line", path: "/admin/consignaciones" },
  { key: "encargos", label: "Pedidos & Encargos", icon: "ri-inbox-archive-line", path: "/admin/encargos" },
  { key: "clientes", label: "Clientes", icon: "ri-user-3-line", path: "/admin/clientes" },
  { key: "asesores", label: "Red de Asesores", icon: "ri-team-line", path: "/admin/asesores" },
  { key: "equipo", label: "Equipo y Administradores", icon: "ri-shield-user-line", path: "/admin/equipo" },
  { key: "cartera", label: "Cartera & Préstamos", icon: "ri-wallet-3-line", path: "/admin/cartera" },
  { key: "contabilidad", label: "Contabilidad & Capital", icon: "ri-calculator-line", path: "/admin/contabilidad" },
  { key: "promociones", label: "Promociones & Combos", icon: "ri-megaphone-line", path: "/admin/promociones" },
  { key: "kit", label: "Kit de Ventas & Marketing", icon: "ri-image-2-line", path: "/admin/kit" },
  { key: "respaldo", label: "Respaldo & Migración", icon: "ri-database-2-line", path: "/admin/respaldo" },
];

export const ASESOR_NAV: NavItem[] = [
  { key: "inicio", label: "Mi Inicio", icon: "ri-home-5-line", path: "/asesor" },
  { key: "catalogo", label: "Catálogo", icon: "ri-store-2-line", path: "/asesor/catalogo" },
  { key: "mi-inventario", label: "Mi Inventario", icon: "ri-archive-2-line", path: "/asesor/inventario" },
  { key: "chulear", label: "Registrar Venta", icon: "ri-checkbox-circle-line", path: "/asesor/chulear" },
  { key: "cuenta", label: "Mi Cuenta", icon: "ri-id-card-line", path: "/asesor/cuenta" },
  { key: "encargo", label: "Pedido por Encargo", icon: "ri-shopping-cart-2-line", path: "/asesor/encargo" },
  { key: "kit", label: "Kit de Ventas", icon: "ri-image-2-line", path: "/asesor/kit" },
];

export const navForRole = (role: Role): NavItem[] => (role === "admin" ? ADMIN_NAV : ASESOR_NAV);